import { ArrowRight, EnvelopeSimple } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";

/* Автор: большое фото с сине-голубым ореолом и текст рядом. Контакты те же, что в подвале. */
export const AuthorBlock = () => (
  <div className="grid items-center gap-10 md:grid-cols-[auto_1fr] md:gap-16">
    <Reveal>
      <div className="relative mx-auto w-fit">
        <div
          aria-hidden="true"
          className="absolute -inset-4 rounded-[2.25rem] bg-gradient-to-br from-accent to-accent-cyan opacity-40 blur-2xl"
        />
        <img
          src="/author.jpg"
          alt="Данил Григорьев"
          width="640"
          height="640"
          loading="lazy"
          className="relative h-56 w-56 rounded-3xl border border-white/10 object-cover sm:h-72 sm:w-72"
          data-testid="author-photo"
        />
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <div className="max-w-[640px]">
        <p className="text-lg text-muted">
          Меня зовут Данил Григорьев. Проект веду один, от разбора до результата, и менеджера между нами нет. Пиши в
          Telegram @d_evoluer или на почту gridepro@yandex.ru.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <a
            href="https://t.me/d_evoluer"
            target="_blank"
            rel="noopener noreferrer"
            className="btn"
            data-testid="author-telegram"
          >
            Написать мне в Telegram
            <ArrowRight size={20} weight="bold" />
          </a>
          <a
            href="mailto:gridepro@yandex.ru"
            className="glass inline-flex min-h-12 items-center gap-2 rounded-xl px-5 text-base text-white/80 transition-colors duration-300 ease-smooth hover:text-white"
          >
            <EnvelopeSimple size={20} />
            Написать на почту
          </a>
        </div>
      </div>
    </Reveal>
  </div>
);
